import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api/client";
import { useDialogs } from "../../components/Dialogs";
import { RelativeTime } from "../../components/RelativeTime";

const KEY = ["connected-apps"] as const;

/** OAuth connections (e.g. a claude.ai connector) the user approved. */
export function ConnectedApps() {
  const qc = useQueryClient();
  const { confirm } = useDialogs();
  const apps = useQuery({ queryKey: KEY, queryFn: api.connectedApps });
  const disconnect = useMutation({
    mutationFn: api.disconnectApp,
    onSettled: () => qc.invalidateQueries({ queryKey: KEY }),
  });
  return (
    <div className="field">
      <span className="field-label">Connected apps</span>
      <p className="muted small">
        Apps that signed in with your account, such as a claude.ai custom connector (add the server URL above as the
        connector's URL and sign in when asked).
      </p>
      {apps.data && apps.data.length > 0 ? (
        <table className="table">
          <thead>
            <tr>
              <th>Shown as</th>
              <th>App</th>
              <th>Connected</th>
              <th>Last used</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {apps.data.map((a) => (
              <tr key={a.id}>
                <td>{a.name}</td>
                <td className="muted small">{a.client_name}</td>
                <td className="muted small">
                  <RelativeTime iso={a.created_at} />
                </td>
                <td className="muted small">{a.last_used_at ? <RelativeTime iso={a.last_used_at} /> : "never"}</td>
                <td className="table-actions">
                  <button
                    className="btn btn-sm btn-ghost-danger"
                    disabled={disconnect.isPending}
                    onClick={async () => {
                      if (await confirm({ title: `Disconnect “${a.name}”?`, body: "It loses access immediately; reconnecting needs a new sign-in.", confirmLabel: "Disconnect", danger: true }))
                        disconnect.mutate(a.id);
                    }}
                  >
                    Disconnect
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="muted small">None yet.</p>
      )}
    </div>
  );
}
